import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ConfirmationLayout from 'shared/lib/components/ConfirmationLayout';
import LineItemsList from 'shared/lib/components/LineItemsList';
import SectionWrapper from 'shared/lib/components/SectionWrapper';
import moment from 'moment-timezone';
import currencyFormatter from 'currency-formatter';
import get from 'lodash/get';
import * as analytics from 'shared/lib/analytics';

const propTypes = {
  purchase: PropTypes.shape({
    propertyAddress: PropTypes.object,
  }),
};

const defaultProps = {
  purchase: {},
};

class CollectiblesEndorsementConfirmationView extends PureComponent {
  componentDidMount() {
    analytics.page('Collectibles - Endorsement Confirmation', {
      categoryCode: this.props.categoryCode,
    });
    this.props.resetCollectiblesEndorsementData();
  }

  formatPrice = price => {
    const { purchase } = this.props;
    return currencyFormatter.format(price, {
      code: get(purchase, 'quote.cart.currency_code'),
    });
  };

  get coverageEndDate() {
    const endDate = get(this.props.policy, 'coverage_end_date');
    return moment(endDate, 'YYYY-MM-DD').format('MMM DD, YYYY');
  }

  render() {
    const {
      account,
      categoryConfig,
      disclaimer,
      policyProvider,
      purchase,
      policy,
    } = this.props;
    const quoteAction = get(purchase, 'quote.action');

    return (
      <div className="CollectiblesEndorsementConfirmationView Container Container--small">
        <ConfirmationLayout
          message="Coverage will not bind until the insurance carrier approves your application. You will receive a confirmation email updating your application status within the next business day."
          policyDocUrl={get(this.props.policy, 'documents[0].url')}
          icon="widgets"
          totals={get(purchase, 'quote.cart.totals')}
          pricePerCycle={get(purchase, 'quote.new_annual_total_premium')}
          phoneNumber={account.phoneNumber}
          isPendingApproval={true}
          disclaimer={disclaimer}
          hideBillingSummary
        >
          <SectionWrapper title="Coverage details">
            <LineItemsList
              rows={[
                [
                  'New premium',
                  `${this.formatPrice(
                    get(purchase, 'quote.new_annual_total_premium')
                  )}/year`,
                ],
                ['Underwritten by', policyProvider],
                [
                  'Deductible',
                  this.formatPrice(get(policy, 'details.deductible')),
                ],
                [
                  'Coverage term',
                  `${moment().format('MMM DD, YYYY')} - ${
                    this.coverageEndDate
                  }`,
                ],
              ]}
            />
          </SectionWrapper>

          <SectionWrapper
            title={`${get(categoryConfig, 'title')} collection details`}
          >
            <LineItemsList
              rows={[
                [
                  'Location',
                  <div>
                    {get(purchase, 'propertyAddress.streetAddress')}
                    {get(purchase, 'propertyAddress.unit') && (
                      <span>
                        {get(purchase, 'propertyAddress.unit')}
                        <br />
                      </span>
                    )}
                    <br />
                    {get(purchase, 'propertyAddress.city')},{' '}
                    {get(purchase, 'propertyAddress.region')}{' '}
                    {get(purchase, 'propertyAddress.postal')}
                  </div>,
                ],
                [
                  'Highest valued item',
                  `${this.formatPrice(
                    get(purchase, 'details.highest_value_item')
                  )}`,
                ],
                [
                  'Total value',
                  `${this.formatPrice(
                    get(purchase, 'details.collection_total_value')
                  )}`,
                ],
              ]}
            />
          </SectionWrapper>

          {quoteAction !== 'no_change' && (
            <SectionWrapper title="Billing details">
              <LineItemsList
                rows={[
                  [
                    <strong>
                      {quoteAction === 'refund'
                        ? 'Refund amount'
                        : 'Balance due'}
                    </strong>,
                    <strong>
                      {this.formatPrice(
                        Math.abs(get(purchase, 'quote.cart.totals.grandtotal'))
                      )}
                    </strong>,
                  ],
                ]}
              />
            </SectionWrapper>
          )}
        </ConfirmationLayout>
      </div>
    );
  }
}

CollectiblesEndorsementConfirmationView.propTypes = propTypes;
CollectiblesEndorsementConfirmationView.defaultProps = defaultProps;

export default CollectiblesEndorsementConfirmationView;
